import { Box, Typography, Button } from "@mui/material";
import axios from 'axios';
import {host} from '../constant/backendpath';

export default function NotificationModal({open,setOpen ,message}) {
  // if (!open) return null;
  const isInvitation = typeof open === "string" && !open.startsWith("REJECTION:");
  const displayMessage = isInvitation
    ? `${open} invites you to join their team, are you willing to join their team?`
    : (message || open || "").replace(/^REJECTION:/, "");

  // Simple stable hash for a message to persist dismissal
  function hashStr(str) {
    let h = 5381;
    for (let i = 0; i < str.length; i++) {
      h = (h * 33) ^ str.charCodeAt(i);
    }
    return (h >>> 0).toString(36);
  }

  const storageKey = `notif_${hashStr(String(displayMessage || open || ''))}`;

  async function handleClick(bool){
    try{
        const res = await axios.post(`${host}notification`,{decision:bool},{withCredentials:true});
        if(res.status === 200){
            // console.log('successfully updated');
            setOpen(false);
        }
    }catch(err){
        // console.log(err);
    }
  }

  function handleOkAndPersist() {
    try {
      localStorage.setItem(storageKey, '1');
    } catch (e) {
      // ignore localStorage errors
    }
    setOpen(false);
  }

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backdropFilter: "blur(6px)", // blur background
        backgroundColor: "rgba(0,0,0,0.3)", // dim effect
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
      }}
    >
      <Box
        sx={{
          width: { xs: '92%', sm: '420px', md: '480px' },
          maxWidth: '92%',
          bgcolor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          p: 2.5,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Notification for You
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
          {displayMessage}
        </Typography>

        {isInvitation ? (
          <Box sx={{ display: "flex", justifyContent: "space-evenly", mt: 2 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "green", "&:hover": { bgcolor: "darkgreen" } }}
              onClick={()=>handleClick(true)}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              sx={{ bgcolor: "red", "&:hover": { bgcolor: "darkred" } }}
              onClick={()=>handleClick(false)}
            >
              No
            </Button>
          </Box>
        ) : (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button variant="contained" onClick={handleOkAndPersist}>
              OK
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}
